import React from 'react';
import { noop } from 'rhombus-react';

const DTREE_TASKS = {
	VERSION_HEDGE_UPLOAD: "Version Hedge Upload",
};

const DTREE_TASK_TO_NOTIFICATION = {
	[DTREE_TASKS.VERSION_HEDGE_UPLOAD]: HedgeUpload,
};

export default function DTreeNotification(props) {
	const { info = {} } = props;
	const Notification = DTREE_TASK_TO_NOTIFICATION[info.task];

	if (!Notification) {
		return <DefaultNotification {...props} />;
	}

	return <Notification {...props} />;
}

// Default Components //

export function DefaultNotification(props) {
	const { info = {} } = props;
	const { iconInfo = {} } = info;
	let message = "Action in Progress";

	if(/in progress/gi.test(info.status)){
		message = "Task in progress...";
	} else if(/complete/gi.test(info.status)){
		message = "Task complete";
	} else if(/success/gi.test(info.status)){
		message = "Task successful";
	} else if (/failed/gi.test(info.status)) {
		message = "Task failed";
	}

	return (
		<>
			<i key="status-icon" className={`ft-ic status-icon ${iconInfo.icon}`} title={iconInfo.title} />
			<div key="body" className="message-body">
				<p>{message}</p>
			</div>
			<DefaultMessageItem key="common" {...props} />
		</>
	);
}

export function DefaultMessageItem({ info = {}, clearMessage = noop }){
	const libraryName = info.data?.creative?.creativeLibrary?.name || "Library";
	const { status } = info;
	let clear;

	if(/in progress/i.test(status)){
		clear = <b key="clear" />; // Included to avoid unwanted behavior around truncating library name
	} else {
		clear = <i key="clear" className="ft-ic fal fa-times clear-message" title="Clear Message" onClick={clearMessage} />;
	}

	return (
		<>
			{clear}
			<b key="empty" />
			<span key="footer" className="message-footer name-overflow" title={libraryName}>{libraryName}</span>
			<time key="time" className="message-time" dateTime={info.timestamp}>{info.prettyTime}</time>
		</>
	);
}

// Task Specific Components //

export function HedgeUpload(props) {
	const { info = {} } = props;
	const { iconInfo = {}, error = {} } = info;
	let message = "";

	if (/in progress/gi.test(info.status)) {
		message = "Decision sheet upload in progress...";
	}
	if (/success/gi.test(info.status)) {
		message = "Decision sheet upload succeeded";
	}
	if (/failed/gi.test(info.status)) {
		message = error.description || "Decision sheet upload failed";
	}

	return (
		<>
			<i key="status-icon" className={`ft-ic status-icon ${iconInfo.icon}`} title={iconInfo.title} />
			<div key="body" className="message-body">
				<p>{message}</p>
			</div>
			<DefaultMessageItem key="common" {...props} />
		</>
	);
}
